import dayjs from 'dayjs'
import { Model } from '@vuex-orm/core'

/* Utils */
import { formatDateToServerString, nextDayFrom } from '../utils/date.utils'

export default class DateSearch extends Model {
  declare id: string
  declare showArrivalData: boolean
  declare showDepartureData: boolean
  declare showStayData: boolean
  declare roomID?: string
  declare ratePlanID?: string
  declare paxAges: number[]
  declare dateFrom: string
  declare dateTo: string

  static entity = 'dateSearches'

  static primaryKey = 'id'

  static fields() {
    const today = new Date()
    const tomorrow = nextDayFrom(today)

    return {
      id: this.uid(),
      showArrivalData: this.boolean(false),
      showDepartureData: this.boolean(false),
      showStayData: this.boolean(false),
      roomID: this.attr(null).nullable(),
      ratePlanID: this.attr(null).nullable(),
      paxAges: this.attr([1, 2]),
      dateFrom: this.attr(formatDateToServerString(today)),
      dateTo: this.attr(formatDateToServerString(tomorrow))
    }
  }

  static get dates() {
    const storedModel = this.query().whereId(1).first()
    return {
      start: storedModel && storedModel.dateFrom,
      end: storedModel && storedModel.dateTo
    }
  }

  static set dates(dates) {
    if (dates.start == null || dates.end == null) {
      throw new TypeError('Incorrect dates passed')
    }

    this.insertOrUpdate({
      data: {
        id: 1,
        dateFrom: formatDateToServerString(dates.start),
        dateTo: formatDateToServerString(dates.end)
      }
    })
  }

  static fetchDates(
    _showStayData: boolean,
    _showArrivalData: boolean,
    _showDepartureData: boolean,
    dateTo = dayjs().startOf('month').add(3, 'month').format("YYYY-MM-DD"),
    dateFrom = dayjs().format("YYYY-MM-DD")
  ) {
    DateSearch.insertOrUpdate({
      data: {
        id: 1,
        dateFrom,
        dateTo
      }
    })
  }
}
